var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.multi) ? _c('div', [(_vm.editable) ? _c('div', [(_vm.unimode) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                已选 "), _c('span', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.result.length))]), _vm._v(" 个 "), _c('a', {
    staticStyle: {
      "color": "#20bf64",
      "font-weight": "bold",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.resultSelector.show()
      }
    }
  }, [_vm._v("编辑")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.result), function(item, index) {
    return (_vm.showAll || _vm.result.length <= 5 || index < 5) ? _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "position": "relative"
      }
    }, [(_vm.clearable) ? _c('Icon', {
      staticClass: "hover clearBtn",
      staticStyle: {
        "position": "absolute",
        "top": "6px",
        "right": "6px"
      },
      attrs: {
        "type": "ios-remove-circle",
        "size": "20",
        "color": "#20bf64"
      },
      on: {
        "click": function($event) {
          return _vm.toClear(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.moveable) ? _c('Icon', {
      staticClass: "hover clearBtn",
      staticStyle: {
        "position": "absolute",
        "top": "6px",
        "right": "54px"
      },
      attrs: {
        "type": "ios-arrow-dropdown-circle",
        "size": "20",
        "color": "#32a14b"
      },
      on: {
        "click": function($event) {
          return _vm.moveDown(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.moveable) ? _c('Icon', {
      staticClass: "hover clearBtn",
      staticStyle: {
        "position": "absolute",
        "top": "6px",
        "right": "30px"
      },
      attrs: {
        "type": "ios-arrow-dropup-circle",
        "size": "20",
        "color": "#32a14b"
      },
      on: {
        "click": function($event) {
          return _vm.moveUp(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('Button', {
      staticClass: "item nowrap",
      attrs: {
        "type": "dashed"
      },
      on: {
        "click": function($event) {
          return _vm.resultSelector.show(index)
        }
      }
    }, [(_vm.$scopedSlots.name) ? [_vm._t("name", null, {
      "item": item
    })] : _c('span', [_vm._v(_vm._s(item.name))])], 2)], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.result.length > 5 && !_vm.showAll) ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "-8px",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "showAll",
    on: {
      "click": function($event) {
        _vm.showAll = true
      }
    }
  }, [_vm._v("\n                    展示全部"), (!_vm.unimode) ? _c('span', [_vm._v("（共"), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.result.length))]), _vm._v("个）")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.unimode) ? _c('div', [(!_vm.max || _vm.result.length < _vm.max) ? _c('Button', {
    staticClass: "item",
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.resultSelector.show()
      }
    }
  }, [_vm._v("+" + _vm._s(_vm.label ? (" " + _vm.label) : ''))]) : _vm._e()], 1) : _vm._e()], 2) : _c('div', [_vm._l((_vm.result), function(item, index) {
    return (_vm.showAll || _vm.result.length <= 5 || index < 5) ? _c('div', {
      key: index,
      staticClass: "readonlyitem"
    }, [(_vm.$scopedSlots.name) ? [_vm._t("name", null, {
      "item": item
    })] : _c('span', [_vm._v(_vm._s(item.name))])], 2) : _vm._e()
  }), _vm._v(" "), (_vm.result.length > 5 && !_vm.showAll) ? _c('div', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "-8px",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "showAll",
    on: {
      "click": function($event) {
        _vm.showAll = true
      }
    }
  }, [_vm._v("\n                    展示全部（共"), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.result.length))]), _vm._v("个）\n                ")])]) : _vm._e()], 2)]) : _c('div', [(_vm.editable) ? _c('div', [(_vm.result) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "position": "relative"
    }
  }, [(_vm.clearable) ? _c('Icon', {
    staticClass: "hover clearBtn",
    staticStyle: {
      "position": "absolute",
      "top": "6px",
      "right": "6px"
    },
    attrs: {
      "type": "ios-remove-circle",
      "size": "20",
      "color": "#20bf64"
    },
    on: {
      "click": function($event) {
        return _vm.toClear()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('Button', {
    staticClass: "item",
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.resultSelector.show()
      }
    }
  }, [(_vm.$scopedSlots.name) ? [_vm._t("name", null, {
    "item": _vm.item
  })] : _c('span', [_vm._v(_vm._s(_vm.result.name))])], 2)], 1) : _c('Button', {
    staticClass: "item",
    attrs: {
      "type": "dashed"
    },
    on: {
      "click": function($event) {
        return _vm.resultSelector.show()
      }
    }
  }, [_vm._v("+" + _vm._s(_vm.label ? (" " + _vm.label) : ''))])], 1) : _c('div', {
    staticClass: "readonlyitem"
  }, [(_vm.$scopedSlots.name) ? [_vm._t("name", null, {
    "item": _vm.item
  })] : _c('span', [_vm._v(_vm._s(_vm.result ? _vm.result.name : ''))])], 2)]), _vm._v(" "), _c('Modal', {
    staticClass: "nopadding",
    attrs: {
      "footer-hide": "",
      "width": _vm.useMendianSelector ? 1200 : 800
    },
    model: {
      value: (_vm.resultSelector.display),
      callback: function($$v) {
        _vm.$set(_vm.resultSelector, "display", $$v)
      },
      expression: "resultSelector.display"
    }
  }, [(_vm.resultSelector.display) ? [(_vm.datatype == 'jigou' && _vm.useMendianSelector) ? _c('MendianSelector', {
    attrs: {
      "current": _vm.current
    },
    on: {
      "cancel": function($event) {
        _vm.resultSelector.display = false
      },
      "mendianSelected": _vm.resultSelector.confirm
    }
  }) : _c('DataSelector', {
    attrs: {
      "options": _vm.resultSelector.options,
      "nopage": _vm.nopage
    },
    on: {
      "cancel": function($event) {
        _vm.resultSelector.display = false
      },
      "confirm": _vm.resultSelector.confirm
    }
  })] : _vm._e()], 2)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4e676906", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e676906","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CustomData.vue
// module id = AnD4
// module chunks = 142